// 2020-07-23export { TropaConsumoComponent } from './tropa-consumo.component';